import { ContentBuilderFieldType } from '../types/content-builder-field.type';
import { ParticipantField } from './participant-field.model';

export class ParticipantDateField extends ParticipantField {
  override controlType = 'date';
  override fieldType: ContentBuilderFieldType = 'participantField';
  constructor(options: { [x in string]: any } = {}) {
    super(options);
    this.type = options['type'] ? options['type'] : 'shortDate';
    this.config.format = options['config']?.format || 'DD/MM/YYYY';
  }
}
